export default "__VITE_PUBLIC_ASSET__d81c27cf__"